import React, { useRef } from 'react';

import styled, { css } from 'styled-components';

import { useAsset } from '~/techstyle-shared/react-assets';
import { Carousel, mobile, desktop } from '~/techstyle-shared/react-components';

import useBuilderConstructorGridInputs from '../../hooks/useBuilderConstructorGridInputs';
import AssetCard from '../AssetCard';

import DiscoveryGuideFilterAssetCard from './DiscoveryGuideFilterAssetCard';
import DiscoveryGuideFilterPill from './DiscoveryGuideFilterPill';

const StyledCarousel = styled(Carousel)`
  .flickity-slider img {
    max-width: none;
  }

  .flickity-button[disabled] {
    display: none;
  }

  .flickity-enabled:focus {
    outline: none;
  }

  .flickity-button:focus {
    outline: none;
    box-shadow: none;
  }

  ${desktop`
    .flickity-prev-next-button {
      &.previous {
        left: -25px;
      }

      &.next {
        right: -25px;
      }
    }
  `}

  ${mobile`
  .flickity-prev-next-button {
     width: 30px;
     height: 30px;
  }
`}
`;

const cellStyle = css`
  counter-increment: carousel-cell;
  width: max-content;
  margin-right: 8px;
`;

const CarouselContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ $hasMarketingCard }) =>
    $hasMarketingCard ? 'auto 1fr' : '1fr'};
  gap: 28px;
  margin: 0 32px;
`;

const FilterPillsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin: 16px 0;
`;

const StyledAssetCard = styled(AssetCard)`
  width: 270px;
  height: 480px;
`;

const DesktopGridDiscoveryGuide = () => {
  const { gridStyleGuide } = useBuilderConstructorGridInputs();

  const marketingCardAssetContainerName =
    gridStyleGuide?.assetContainers?.marketingCard;
  const marketingCardAssetContainer = useAsset(marketingCardAssetContainerName);

  const desktopAssetContainerName = gridStyleGuide?.assetContainers?.desktop;
  const desktopAssetContainer = useAsset(desktopAssetContainerName, {
    multi: true,
  });

  const desktopAssets = desktopAssetContainer?.data?.assets || [];

  const marketingCardAsset = marketingCardAssetContainer?.data?.assets?.[0];

  // flickity carousel dependencies
  const flickityRef = useRef();
  const carouselOptions = {
    contain: true,
    pageDots: false,
    resize: true,
    groupCells: true,
    cellStyle,
    freeScroll: true,
    wrapAround: false,
    autoPlay: false,
  };

  if (!gridStyleGuide) {
    return null;
  }

  return (
    <div>
      <CarouselContainer $hasMarketingCard={!!marketingCardAsset}>
        {marketingCardAsset && <StyledAssetCard {...marketingCardAsset} />}
        <StyledCarousel {...carouselOptions} flickityRef={flickityRef}>
          {desktopAssets.map((asset) => (
            <DiscoveryGuideFilterAssetCard
              key={asset.id}
              {...asset}
              onLoad={() => {
                if (flickityRef?.current) {
                  flickityRef.current.resize();
                }
              }}
            />
          ))}
        </StyledCarousel>
      </CarouselContainer>
      <FilterPillsContainer>
        {desktopAssets.map((asset) => (
          <DiscoveryGuideFilterPill key={asset.id} {...asset} />
        ))}
      </FilterPillsContainer>
    </div>
  );
};

export default DesktopGridDiscoveryGuide;
